export * from 'server/models/UserRole';


// WEBPACK FOOTER //
// ./data/models/UserRole.ts